import { SearchSortFilter } from '../shared/searchSortFilter';

export class TagsFilter extends SearchSortFilter {
  constructor() {
    super();
  }
}
